import { render, staticRenderFns } from "./self-inspection.vue?vue&type=template&id=537a52d2&scoped=true&"
import script from "./self-inspection.vue?vue&type=script&lang=js&"
export * from "./self-inspection.vue?vue&type=script&lang=js&"
import style0 from "./self-inspection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./self-inspection.vue?vue&type=style&index=1&id=537a52d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a52d2",
  null
  
)

export default component.exports